import React, { memo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import Heading from 'components/Luxkit/Typography/Heading'

import LineCheckIcon from 'components/Luxkit/Icons/line/LineCheckIcon'
import TextButton from 'components/Luxkit/Button/TextButton'

const Categories = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-row-gap: ${rem(2)};
  margin: ${rem(4)} 0 0 0;
`

const Category = styled.li`
  display: flex;
  align-items: center;
  margin: ${rem(4)} 0 0;

  & > svg {
    margin-right: ${rem(12)};
  }
`

const ViewAllButton = styled(TextButton)`
  margin: ${rem(16)} 0 0;
`

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary;
}

function BedbankPopularFacilities(props: Props) {
  return <div>
    <Heading variant="heading4" as="h4">Popular Facilities</Heading>
    <Categories>
      {props.offer.popularFacilities.map((categoryName) => (
        <Category key={categoryName}>
          <LineCheckIcon size="S" />{categoryName}
        </Category>
      ))}
    </Categories>
    <ViewAllButton outdent="left" kind="tertiary" href="#facilities-all">
      View all facilities
    </ViewAllButton>
  </div>
}

export default memo(BedbankPopularFacilities)
